import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Calculator from './Calculator';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import { bindQuote } from 'actions/quotes';
import CircularProgress from '@material-ui/core/CircularProgress';
import { fetchApplication } from '/actions/applications';

const styles = {
  appBar: {
    position: 'relative',
    marginBottom: '20px'
  },
  flex: {
    flex: 1,
  },
}

class CalculatorDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, quoteUuid: null };
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  setQuoteUuid = (quoteUuid) => {
    this.setState({ quoteUuid });
  }

  onQuote = () => {
    this.setState({ open: false });
    if (this.props.applicationNumber) {
      this.props.dispatch(fetchApplication(this.props.applicationNumber));
    }
  }

  handleSubmit = () => {
    const { organisationId, dispatch } = this.props;
    const { quoteUuid } = this.state;
    dispatch(bindQuote(organisationId, quoteUuid, this.props.applicationNumber, this.onQuote));
  }

  transition = (props) => {
    return <Slide direction="up" {...props} />;
  }

  onClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
    this.setState({ open: true });
  }

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <CircularProgress color="primary" thickness={7} />
      );
    }
  }

  render = () => {
    const { classes, buttonLabel, buttonStyles } = this.props;
    return (
      <div>
        <Button
          className={buttonStyles}
          color='primary'
          variant="raised"
          onClick={this.onClick}
          disabled={this.props.disabled}
        >
          {buttonLabel}
        </Button>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={this.transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="default" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit" className={classes.flex}>
                New Quote
              </Typography>
              <Button onClick={this.handleSubmit} type='submit' color='default'>
                Submit
              </Button>
            </Toolbar>
          </AppBar>
          { this.renderSpinner() }
          <DialogContent>
            <Calculator
              setQuoteUuid={this.setQuoteUuid}
              applicationNumber={this.props.applicationNumber}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return { showSpinner: state.app.showSpinner }
};

const connected = connect(mapStateToProps)(CalculatorDialog);
export default withStyles(styles)(connected);



// WEBPACK FOOTER //
// ./src/components/Loans/CalculatorDialog.js